import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { createProfil, createdProfil, updateProfil, updatedProfil, deleteProfil, deletedProfil } from './actions';

import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  errorType: undefined,
  data: [],
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(createProfil, (state) => {
      state.status = 'loading';
    })
    .addCase(createdProfil, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(updateProfil, (state) => {
      state.status = 'loading';
    })
    .addCase(updatedProfil, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(deleteProfil, (state) => {
      state.status = 'loading';
    })
    .addCase(deletedProfil, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
        state.errorType = 'delete';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'Profil') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
